import  { instance  } from "../api";


const fetchlivrableByActif = (setLivrableAttributes, selectedActif ) => {
   
      instance.get(`/api/livrables/actif/${selectedActif.id_actif_gexpertise}`)
      .then((result)=>  { 
        setLivrableAttributes(result.data)
     
     
     })    
              
    .catch ((error) =>{console.log('error', error)
      
    })
};


export default fetchlivrableByActif;

export const shareFile=(selectedLivrable, email)=>{
  instance.post(`/api/livrables/${selectedLivrable}/formulaire/partager`, email)
}
 